// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rGkns","badges":"styles_badges__1EI5r"};